define(function(require, exports, module) {
    'use strict';
    var $ = require('j');
    var AbstractTracker = require('modules/trackers/abstract.tracker');
    var core = require('core');

    var GameTracker = AbstractTracker.extend({
        defaults: {
            gameWillBePlayedMaybe: {},
            $el: $('#application')
        },

        events: [
            'gamePortletPersonalizedGrid',
            'gamePortletDisplay',
            'gamePortletSearch',
            'gamePortletPage',
            'gamePortletView',
            'gamePortletCategoryChange',
            'gamePortletSort',
            'gameFavoritesChange',
            'gameGameDisplay',
            'gameGameLaunch'
        ],

        subscribe: function() {
            this.listenTo(core, {
                'game:launch:maybe': this._handleGameLaunchMaybe,
                'game:launch': this._handleGameLaunch
            });
        },

        /**
         * Get web content id if there is one for particular game
         *
         * @param  {jBone} $game
         * @return {string|Undefined}
         */
        getWebContentId: function($game) {
            var $webContent = $game.parents('[data-web-content-id]');
            if ($webContent.length) {
                return $webContent.data('webContentId');
            }
        },

        _handleGameLaunchMaybe: function(game) {
            this.set('gameWillBePlayedMaybe', game);
        },

        _handleGameLaunch: function(game, isRealMode, queryString, options) {
            if (game.gameCode !== this.get('gameWillBePlayedMaybe').gameCode && !(options && options.isReactGame)) {
                return;
            }

            var gameWillBePlayedMaybe = this.get('gameWillBePlayedMaybe');
            var gameLaunchEvent = {
                launchType: isRealMode ? 'Real' : 'Demo',
                gameCode: game.gameCode,
                gameName: game.name || game.gameName
            };

            if (options && options.isReactGame) {
                ['container', 'gameFeed', 'gameName'].forEach(function(fieldName) {
                    gameLaunchEvent[fieldName] = options[fieldName] || gameLaunchEvent[fieldName];
                });
            } else {
                ['container', 'webContentId', 'feedName'].forEach(function(fieldName) {
                    if (gameWillBePlayedMaybe[fieldName]) {
                        gameLaunchEvent[fieldName] = gameWillBePlayedMaybe[fieldName] || gameLaunchEvent[fieldName];
                    }
                });
            }

            this.track('gameGameLaunch', gameLaunchEvent);
        }
    });

    module.exports = GameTracker;
});
